import { FC } from 'react';
import { Heading } from '@wunder-mobility/ui-components';
import { useNavigate } from 'react-router';
import { Trans } from '@lingui/react/macro';
import FullScreen from '@/core/components/Layouts/FullScreen';
import WhiteLabelLogo from '@/core/components/UI/WhiteLabelLogo';
import UserAvatarDropdown from '@/core/components/UI/UserAvatarDropdown';
import SubscriptionOverview from '@/features/subscriptions/components/SubscriptionOverview/SubscriptionOverview';

const Subscriptions: FC = () => {
  const navigate = useNavigate();

  return (
    <FullScreen
      onClose={() => navigate('/')}
      title={<WhiteLabelLogo />}
      actions={<UserAvatarDropdown />}
      mainSize="wide"
      main={
        <>
          <Heading marginBottom={24} size={4}>
            <Trans id="subscriptions.title">Subscriptions</Trans>
          </Heading>
          <SubscriptionOverview />
        </>
      }
    />
  );
};

export default Subscriptions;
